import { addClass, removeClass, toggle, makeEl } from '../common/Utils';
import { IAutoSuggest } from "../interface/IAutoSuggest";

export default class SuggestList {

    private wrapper: HTMLElement;
    private resultUL: HTMLElement;

    constructor(private option: IAutoSuggest, private suggestWrap:HTMLElement, private inputEl: HTMLInputElement, private submitFn: ()=>void){
        this.wrapper = makeEl('div', this.suggestWrap, {'data-name':"suggest_list"});
        const scroller = makeEl('div', this.wrapper, {'data-name':"suggest_scroll"});
        this.resultUL = makeEl('ul', scroller);
    }

    public reset(_loadedKeyword: string, _data: {id:string; keyword:string;}[]){
        this.removeEvents();
        this.toggleResult(_data.length>0);
        this.resultUL.innerHTML = this.templ(_loadedKeyword, _data);
        this.addEvents();
    }

    private templ(_loadedKeyword: string, _data: {id:string; keyword:string;}[]){
        let list = '';
        if(_data.length){
            let key = _loadedKeyword.replace('(', '\\(').replace(')', '\\)');
            let reg = new RegExp(key, 'i');
            list = _data.map( (item, idx) => {
                const regStr = reg.exec(item.keyword);
                if (!regStr) return '';
                const str = item.keyword.replace(regStr[0], `<mark>${regStr[0]}</mark>`);
                return `<li data-idx="${idx}" data-keyword="${item.keyword}">${str}</li>`; 
            } ).join('');
        }
        return list;
    }

    private addEvents(){
        document.querySelectorAll<HTMLElement>( this.option.selector + " [data-name='suggest_scroll'] ul li" ).forEach(it=>{
            it.addEventListener('click', (e: MouseEvent) => {
                const ele = e.currentTarget as HTMLElement;
                this.inputEl.value =  ele.dataset.keyword as string;
                this.submitFn();
            });
        });
    }

    private removeEvents(){
        document.querySelectorAll<HTMLElement>( this.option.selector + " [data-name='suggest_scroll'] ul li" ).forEach(it=>{
            it.removeEventListener('click', (e: MouseEvent) => {
                const ele = e.currentTarget as HTMLElement;
                this.inputEl.value =  ele.dataset.keyword as string;
                this.submitFn();
            });
        });
    }

    public focusChange( _direction = 1 ){
        let newFocusEl: HTMLElement | null = null;
        let oldFocusEl: HTMLElement | null = this.resultUL.querySelector('.focus');

        if(_direction === 1){
            newFocusEl = ( oldFocusEl )? <HTMLElement>oldFocusEl.nextElementSibling: this.resultUL.querySelector('li:first-child');
        }
        if(_direction === -1){
            newFocusEl = ( oldFocusEl )? <HTMLElement>oldFocusEl.previousElementSibling: this.resultUL.querySelector('li:last-child');
        }

        this.toggleResult(newFocusEl !== null);
        this.resultUL.querySelectorAll('li').forEach(it=>removeClass(it, 'focus'));

        let dbKeyword = '';

        if( newFocusEl !== null ){
            addClass(newFocusEl, 'focus');
            dbKeyword = newFocusEl.dataset.keyword as string;
            this.inputEl.value = dbKeyword;
        }

        return dbKeyword;
    }

    public get ilLength(){
        return this.resultUL.querySelectorAll('li').length;
    }

    public get inner(){
        return this.resultUL.innerHTML;
    }

    public set inner(_str:string){
        this.resultUL.innerHTML = _str;
    }

    public removeFocus(){
        this.resultUL.querySelectorAll('li').forEach(it=>removeClass(it, 'focus'));
    }

    public toggleResult(_isShow=true){
        toggle( this.wrapper, _isShow);
        if(!_isShow) this.removeFocus();
    }

} // end of class